export default "__VITE_ASSET__82e8a414__"